import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddNote',
  emits: ["save", "cancel"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const noteValue = ref('');
const modalVisible = ref(true);

const save = () => {
  emit('save', noteValue.value);
  return;
};

const cancel = () => {
  emit('cancel');
  return;
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container add-note__modal",
    draggable: false,
    modal: true,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "dialog__header" }, [
        _createElementVNode("h2", { textContent: 'Add Note' })
      ], -1)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        id: "cancel_notes_btn",
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        id: "save_notes_btn",
        type: "primary",
        text: 'Add Note',
        disabled: !noteValue.value.length,
        onClick: save
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Textarea), {
        modelValue: noteValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((noteValue).value = $event)),
        class: "w-full",
        "auto-resize": true,
        rows: "7",
        cols: "77",
        autofocus: ""
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})